import { render, staticRenderFns } from "./SettingsItemLayout.vue?vue&type=template&id=3ad48b0f"
import script from "./SettingsItemLayout.vue?vue&type=script&lang=js"
export * from "./SettingsItemLayout.vue?vue&type=script&lang=js"
import style0 from "./SettingsItemLayout.vue?vue&type=style&index=0&id=3ad48b0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports